export default __webpack_public_path__ + "static/media/bg_mobile_bussines.4cc7f8f7.svg";